import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Lock, ArrowRight } from 'lucide-react';
export function SignIn() {
  return <div className="min-h-[calc(100vh-200px)] bg-gradient-to-br from-gray-900 via-[#0E578E] to-gray-900 flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-2133">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-2134">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#01AAE7] rounded-full blur-3xl animate-pulse" data-id="element-2135"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-2136"></div>
      </div>

      {/* Diagonal Lines Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)`
    }} data-id="element-2137"></div>

      <div className="max-w-md w-full relative z-10" data-id="element-2138">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-2139">
          <h2 className="text-4xl font-black text-white mb-2" data-id="element-2140">Welcome Back</h2>
          <p className="text-white/80 text-lg" data-id="element-2141">
            Sign in to continue your journey
          </p>
        </div>

        {/* Sign In Card */}
        <div className="bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl p-8 border border-white/20" data-id="element-2142">
          <form className="space-y-6" data-id="element-2143">
            {/* Email Input */}
            <div data-id="element-2144">
              <label className="block text-sm font-bold text-gray-700 mb-3" data-id="element-2145">
                Email Address
              </label>
              <div className="relative" data-id="element-2146">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-2147" />
                <input type="email" placeholder="you@example.com" className="w-full pl-12 pr-4 py-4 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-2148" />
              </div>
            </div>

            {/* Password Input */}
            <div data-id="element-2149">
              <label className="block text-sm font-bold text-gray-700 mb-3" data-id="element-2150">
                Password
              </label>
              <div className="relative" data-id="element-2151">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-2152" />
                <input type="password" placeholder="••••••••" className="w-full pl-12 pr-4 py-4 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-2153" />
              </div>
            </div>

            {/* Remember Me & Forgot Password */}
            <div className="flex items-center justify-between" data-id="element-2154">
              <label className="flex items-center gap-2 cursor-pointer group" data-id="element-2155">
                <input type="checkbox" className="w-5 h-5 rounded border-2 border-gray-300 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer" data-id="element-2156" />
                <span className="text-sm text-gray-700 group-hover:text-[#0E578E] transition-colors font-medium" data-id="element-2157">
                  Remember me
                </span>
              </label>
              <a href="#" className="text-sm font-bold text-[#01AAE7] hover:text-[#0E578E] transition-colors" data-id="element-2158">
                Forgot password?
              </a>
            </div>

            {/* Sign In Button */}
            <button type="submit" className="group w-full bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold py-4 px-6 rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center justify-center gap-2 relative overflow-hidden" data-id="element-2159">
              <span className="relative z-10" data-id="element-2160">Sign In</span>
              <ArrowRight className="h-5 w-5 relative z-10 transition-transform duration-300 group-hover:translate-x-1" data-id="element-2161" />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" data-id="element-2162"></div>
            </button>
          </form>

          {/* Divider */}
          <div className="relative my-8" data-id="element-2163">
            <div className="absolute inset-0 flex items-center" data-id="element-2164">
              <div className="w-full border-t border-gray-200" data-id="element-2165"></div>
            </div>
            <div className="relative flex justify-center" data-id="element-2166">
              <span className="bg-white px-4 text-sm font-semibold text-gray-500" data-id="element-2167">
                Or continue with
              </span>
            </div>
          </div>

          {/* Social Login - Branded Colors */}
          <div className="grid grid-cols-2 gap-3" data-id="element-2168">
            {/* Google Button - Official Colors */}
            <button className="flex items-center justify-center gap-2 px-4 py-3 bg-white border-2 border-gray-200 rounded-xl hover:bg-gray-50 hover:border-gray-300 transition-all font-semibold text-gray-700 text-sm shadow-sm hover:shadow-md group" data-id="element-2169">
              <svg className="w-5 h-5" viewBox="0 0 24 24" data-id="element-2170">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-2171" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-2172" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-2173" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-2174" />
              </svg>
              <span className="group-hover:text-gray-900 transition-colors" data-id="element-2175">
                Google
              </span>
            </button>

            {/* Facebook Button - Official Colors */}
            <button className="flex items-center justify-center gap-2 px-4 py-3 bg-[#1877F2] hover:bg-[#166FE5] border-2 border-[#1877F2] hover:border-[#166FE5] rounded-xl transition-all font-semibold text-white text-sm shadow-sm hover:shadow-md" data-id="element-2176">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-2177">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-2178" />
              </svg>
              Facebook
            </button>
          </div>

          {/* Sign Up Link */}
          <div className="mt-8 text-center" data-id="element-2179">
            <p className="text-sm text-gray-600" data-id="element-2180">
              Don't have an account?{' '}
              <Link to="/create-account" className="font-bold text-[#01AAE7] hover:text-[#0E578E] transition-colors" data-id="element-2181">
                Create one now
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>;
}